import { render, staticRenderFns } from "./side-item.vue?vue&type=template&id=3137d89e&"
import script from "./side-item.vue?vue&type=script&lang=js&"
export * from "./side-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports